import { CustomTextInput } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import {
  BankIDInputMeta,
  CorporateNameInputMeta,
} from '../../containers/forms/commonMeta';

type Props = {
  register?: any,
  hasError?: any,
  isLoading?: boolean,
};

export const BankCorporateInputs: React.FC<Props> = ({
  register,
  isLoading,
  hasError,
}) => {
  return (
    <CC.Flex mt="2%" direction={{ base: 'column', sm: 'row' }}>
      <CustomFormControl
        isLoading={isLoading}
        mr="5%"
        isInvalid={!!hasError[BankIDInputMeta.name]}
        label={BankIDInputMeta.label}
      >
        <CustomTextInput
          size={'md'}
          meta={BankIDInputMeta}
          register={register(BankIDInputMeta.name)}
          hasError={hasError[BankIDInputMeta.name]}
          defaultValue={'10008'}
        />
      </CustomFormControl>
      <CustomFormControl
        isLoading={isLoading}
        isInvalid={!!hasError[CorporateNameInputMeta.name]}
        label={CorporateNameInputMeta.label}
      >
        <CustomTextInput
          meta={CorporateNameInputMeta}
          register={register(CorporateNameInputMeta.name)}
          hasError={hasError[CorporateNameInputMeta.name]}
          defaultValue={'MA BANQUE'}
        />
      </CustomFormControl>
    </CC.Flex>
  );
};
